import { Fragment, useState, forwardRef } from "react";
import clsx from "clsx";
import { Section, Text } from "@/components";
import { ToggleHover, HoverIcon } from "./components";
import "./KeyBenefits.scss";


const data = [
  {
    id: 1,
    title: "High Volume\nInvestors",
    subTitle: "Accelerate Your Due Diligence Without Compromise",
    description:
      "Prioritize with precision—even when reviewing dozens of deals a week.",
    icon: "/images/home/mountain.png",
    alt: "Wired outline dividends",
    benefits: ["Venture Capitalists", "Accelerators", "Commercial Real Estate"],
    toggleText: "The Full Breakdown",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Reviewing dozens or hundreds of deals a quarter often leads to rushed diligence and missed signals.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "Surface the factors most likely to enhance or erode investment value and direct your team’s attention to the questions that matter most.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Scale your pipeline without sacrificing rigor - move fast without missing what matters.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 2,
    title: "Diverse Asset\nInvestors",
    subTitle: "Expert diligence, even outside your domain.",
    description:
      "AI that adapts to any sector, so you can go deep without specialists.",
    icon: "/images/home/business-and-trade.png",
    alt: "Wired outline dividends",
    benefits: ["Family Offices", "Cross-Sector VCs", "Investment Banks"],
    toggleText: "Learn More",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Cross-sector investing stretches internal expertise and makes it hard to know what to ask or where to dig.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ adapts to any sector—generating relevant questions, identifying key risks, and flagging gaps without requiring domain-specific expertise.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Invest confidently in unfamiliar markets with AI that knows what to look out for.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 3,
    title: "Say Goodbye\nto Ctrl+F Chaos",
    subTitle: "Handle the entire data room without lifting a finger.",
    description:
      "IntelliRoom™ reads every file, so you don’t have to scroll, search, or stress.",
    icon: "/images/home/folder.png",
    alt: "Wired outline clock",
    benefits: ["Private Equity", "Investment Banks", "Family Offices"],
    toggleText: "See How it Helps",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Data rooms are bloated, forcing deal teams to waste hours hunting through PDFs, decks, and legal docs.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ reads the entire data room, indexes your files, and answers instantly—no manual scrolling or searching required.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Cut review time dramatically and spot critical issues before they’re missed.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 4,
    title: "AI for Spreadsheet\nNative Teams",
    subTitle: "Finally, an AI that speaks Excel.",
    description:
      "Extract insights, answer questions, and perform calculations.",
    icon: "/images/home/ai-excel.png",
    alt: "Wired outline magic wand",
    benefits: ["Private Equity", "Investment Banks", "Family Offices"],
    toggleText: "Problem, Benefit, & Outcome",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Problem Traditional AI tools fail to extract meaning from Excel because the data is unstructured.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ is built to interpret .xls files, pulling key figures, performing calculations on xls based data sets, and answering diligence questions directly from your workbooks.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Spend less time decoding spreadsheets and more time making better-informed decisions.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
];

const mobileData = [
  {
    id: 1,
    title: "High Volume\nInvestors",
    subTitle: "Accelerate Your Due Diligence Without Compromise",
    description:
      "Prioritize with precision—even when reviewing dozens of deals a week.",
    icon: "/images/home/mountain.png",
    alt: "Wired outline dividends",
    benefits: ["Venture Capitalists", "Accelerators", "Com. Real Estate"],
    toggleText: "The Full Breakdown",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Reviewing dozens or hundreds of deals a quarter often leads to rushed diligence and missed signals.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "Surface the factors most likely to enhance or erode investment value and direct your team’s attention to the questions that matter most.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Scale your pipeline without sacrificing rigor - move fast without missing what matters.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 2,
    title: "Diverse Asset\nInvestors",
    subTitle: "Expert diligence, even outside your domain.",
    description:
      "AI that adapts to any sector, so you can go deep without specialists.",
    icon: "/images/home/business-and-trade.png",
    alt: "Wired outline dividends",
    benefits: ["Family Offices", "Cross-Sector VCs", "Investment Banks"],
    toggleText: "Learn More",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Cross-sector investing stretches internal expertise and makes it hard to know what to ask or where to dig.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ adapts to any sector—generating relevant questions, identifying key risks, and flagging gaps without requiring domain-specific expertise.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Invest confidently in unfamiliar markets with AI that knows what to look out for.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 3,
    title: "Say Goodbye\nto Ctrl+F Chaos",
    subTitle: "Handle the entire data room without lifting a finger.",
    description:
      "IntelliRoom™ reads every file, so you don’t have to scroll, search, or stress.",
    icon: "/images/home/folder.png",
    alt: "Wired outline clock",
    benefits: ["Private Equity", "Investment Banks", "Family Offices"],
    toggleText: "See How it Helps",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Data rooms are bloated, forcing deal teams to waste hours hunting through PDFs, decks, and legal docs.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ reads the entire data room, indexes your files, and answers instantly—no manual scrolling or searching required.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Cut review time dramatically and spot critical issues before they’re missed.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
  {
    id: 4,
    title: "AI for Spreadsheet\nNative Teams",
    subTitle: "Finally, an AI that speaks Excel.",
    description:
      "Extract insights, answer questions, and perform calculations.",
    icon: "/images/home/ai-excel.png",
    alt: "Wired outline magic wand",
    benefits: ["Private Equity", "Investment Banks", "Family Offices"],
    toggleText: "Problem, Benefit, & Outcome",
    extraInfos: [
      {
        "key": "Problem",
        "value": "Problem Traditional AI tools fail to extract meaning from Excel because the data is unstructured.",
        "icon": "/images/home/angry.svg",
      },
      {
        "key": "Benefit",
        "value": "IntelliRoom™ is built to interpret .xls files, pulling key figures, performing calculations on xls based data sets, and answering diligence questions directly from your workbooks.",
        "icon": "/images/home/star.svg",
      },
      {
        "key": "Outcome",
        "value": "Spend less time decoding spreadsheets and more time making better-informed decisions.",
        "icon": "/images/home/rocket.svg",
      },
    ]
  },
];

export const KeyBenefitsSection = forwardRef<HTMLElement, {}>((props, ref) => {
  const [activeItems, setActiveItems] = useState<number[]>([]);

  const toggleItem = (index: number): void => {
    setActiveItems((prev) => 
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <Section
      ref={ref}
      id="key-benefits-section"
      className="bg-black gap-8 md:gap-[79px] px-4 py-[60px] md:py-[100px]"
    >
      <div className="flex w-full">
        <div className="mx-auto text-center">
          <h2 className="flex justify-center font-heading-main text-center gap-2">
            <Text.Heading size="2xl" className="text-white key-benefit-item-title !text-[48px] md:!text-[100px]">Solutions</Text.Heading>
          </h2>

          {/* desktop version */}
          <Text.Description size="sm" className="hidden md:block max-w-[723px] !font-300 text-center md:!text-[#FEFEFE] md:!text-[18px] md:leading-[26px] md:mt-4">
            Whether you're buried in data rooms, deep in spreadsheets, moving fast through high-volume pipelines, or investing across sectors, IntelliRoom™ meets you where you work - and helps you move faster, with fewer blind spots.
          </Text.Description>

          {/* mobile version */}
          <Text.Description size="sm" className="block md:hidden max-w-[335px] md:max-w-[637px] font-normal text-center !text-[#C7C7C7] leading-[20px] md:leading-[26px] md:mt-3">
            From data rooms to spreadsheets to fast-moving deals, IntelliRoom™ fits your flow - helping you move faster and see what others miss.
          </Text.Description>
        </div>
      </div>

      <div className="px-0 sm:p-10 lg:p-0">
        {/* desktop version */}
        <div className="key-benefit-grid w-full max-w-[1260px] hidden md:grid grid-cols-1 lg:grid-cols-2 gap-5">
          {data.map((item, index) => (
            <Fragment key={`benefit-item-${item.id}`}>
              <div className={`key-benefit-item relative border-none ${activeItems.includes(index) && 'active'}`}>
                <div className="key-benefit-item-hover">
                  <img
                    className="w-full h-auto"
                    alt={item.alt}
                    src="/images/home/key-benefit-hover-effect.png"
                    loading="lazy" // Added lazy loading
                  />
                </div>
                <div className={`key-benefit-item-content relative`}>
                  <div>
                    <div className="flex flex-col gap-5 p-0">
                      <img
                        className="w-[166px] h-[170px]"
                        alt={item.alt}
                        src={item.icon}
                        loading="lazy" // Added lazy loading
                      />

                      <div className="flex flex-col items-start gap-3.5">
                        <div className="flex flex-col">
                          <Text.Heading size="md" className="benefit-card-title text-[#fefefe] font-semibold">
                            {item.title.split('\n')[0]}
                          </Text.Heading>
                          <Text.Heading size="md" className="benefit-card-title text-[#fefefe] font-semibold">
                            {item.title.split('\n')[1]}
                          </Text.Heading>
                        </div>

                        <div>
                          <Text.Description size="xs" className="benefit-card-subtitle text-white font-500 text-left !text-[14px] md:!text-[16px]">
                            {item.subTitle}
                          </Text.Description>
                          <Text.Description size="2xs" className="benefit-card-description !text-[#A0A0A0] font-light text-left !text-[12px] md:!text-[14px]">
                            {item.description}
                          </Text.Description>
                        </div>
                      </div>

                      <div className="features-group flex flex-row gap-[9px] lg:gap-4">
                        {item.benefits.map((benefit, index) => (
                          <div key={`benefit-option-${index}`} className="flex items-center gap-1.5">
                            <img
                              src="/images/home/active-tick.svg"
                              alt={benefit}
                              className="w-2.5 h-2.5 md:w-[14px] md:h-[14px]"
                              loading="lazy" // Added lazy loading
                            />
                            <Text.Description size="2xs" className="text-white md:!text-[12px] xl:!text-[14px] font-500 benefit-card-beneifit-item">
                              {benefit}
                            </Text.Description>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mt-6 md:mt-10">
                      <ToggleHover item={item} onClick={() => toggleItem(index)} />
                    </div>
                  </div>

                  <div className={clsx(
                    "active-benefit-detail w-full h-full",
                    {
                      'show': activeItems.includes(index)
                    }
                  )}>
                    <div className="h-full">
                      <div className="h-full flex z-100 px-5 md:px-16 py-[30px] md:py-11">
                        <div className="m-auto flex flex-col gap-[50px] p-0">
                          {item.extraInfos.map((info, infoIndex) => (
                            <div
                              key={`extra-${index}-${infoIndex}`}
                              className="flex gap-3"
                            >
                              <img
                                className="w-[56px] h-[56px] mt-1.5"
                                alt={info.key}
                                src={info.icon}
                                loading="lazy" // Added lazy loading
                              />

                              <div className="gap-3">
                                <Text.Description size="lg" className="text-white md:!font-400 text-left !text-[14px] md:!text-[22px] md:!leading-[33px]">
                                  {info.key}
                                </Text.Description>
                                <Text.Description size="sm" className="!text-[#A9AAB0] text-left !text-[12px] md:!text-[18px] md:!font-light">
                                  {info.value}
                                </Text.Description>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="close-benefit absolute top-4 right-4 cursor-pointer" onClick={() => toggleItem(index)}>
                        <HoverIcon className="close-circle-icon w-16 h-16" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ))}
        </div>

        {/* mobile version */}
        <div className="key-benefit-grid w-full max-w-[1260px] grid grid-cols-1 lg:grid-cols-2 gap-5 md:hidden">
          {mobileData.map((item, index) => (
            <Fragment key={`benefit-item-${item.id}`}>
              <div className={`key-benefit-item relative border-none ${activeItems.includes(index) && 'active'}`}>
                <div className="key-benefit-item-hover">
                  <img
                    className="w-full h-auto"
                    alt={item.alt}
                    src="/images/home/key-benefit-hover-effect.png"
                    loading="lazy" // Added lazy loading
                  />
                </div>
                <div className={`key-benefit-item-content relative`}>
                  <div>
                    <div className="flex flex-col gap-5 p-0">
                      <img
                        className="w-[166px] h-[170px]"
                        alt={item.alt}
                        src={item.icon}
                        loading="lazy" // Added lazy loading
                      />

                      <div className="flex flex-col items-start gap-3.5">
                        <div className="flex flex-col">
                          <Text.Heading size="md" className="benefit-card-title text-[#fefefe] font-semibold">
                            {item.title.split('\n')[0]}
                          </Text.Heading>
                          <Text.Heading size="md" className="benefit-card-title text-[#fefefe] font-semibold">
                            {item.title.split('\n')[1]}
                          </Text.Heading>
                        </div>

                        <div>
                          <Text.Description size="xs" className="benefit-card-subtitle text-white font-500 text-left !text-[14px] md:!text-[16px]">
                            {item.subTitle}
                          </Text.Description>
                          <Text.Description size="2xs" className="benefit-card-description !text-[#A0A0A0] font-light text-left !text-[12px] md:!text-[14px]">
                            {item.description}
                          </Text.Description>
                        </div>
                      </div>

                      <div className="features-group flex flex-row flex-wrap gap-x-[9px] lg:gap-x-4">
                        {item.benefits.map((benefit, index) => (
                          <div key={`benefit-option-${index}`} className="flex items-center gap-1.5">
                            <img
                              src="/images/home/active-tick.svg"
                              alt={benefit}
                              className="w-2.5 h-2.5 md:w-[14px] md:h-[14px]"
                              loading="lazy" // Added lazy loading
                            />
                            <Text.Description size="2xs" className="text-white text-[12px] font-500 benefit-card-beneifit-item">
                              {benefit}
                            </Text.Description>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mt-6 md:mt-10">
                      <ToggleHover item={item} onClick={() => toggleItem(index)} />
                    </div>
                  </div>

                  <div className={clsx(
                    "active-benefit-detail w-full h-full",
                    {
                      'show': activeItems.includes(index)
                    }
                  )}>
                    <div className="h-full">
                      <div className="h-full flex z-100 px-5 md:px-16 py-[30px] md:py-11">
                        <div className="m-auto flex flex-col gap-[50px] p-0">
                          {item.extraInfos.map((info, infoIndex) => (
                            <div
                              key={`extra-${index}-${infoIndex}`}
                              className="flex gap-3"
                            >
                              <img
                                className="w-[56px] h-[56px] mt-1.5"
                                alt={info.key}
                                src={info.icon}
                                loading="lazy" // Added lazy loading
                              />

                              <div className="gap-3">
                                <Text.Description size="lg" className="text-white !font-500 text-left !text-[20px] md:!text-[22px] md:!leading-[33px]">
                                  {info.key}
                                </Text.Description>
                                <Text.Description size="sm" className="!text-[#A9AAB0] !font-light text-left !text-[16px] md:!text-[18px]">
                                  {info.value}
                                </Text.Description>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="close-benefit absolute top-4 right-4 cursor-pointer" onClick={() => toggleItem(index)}>
                        <HoverIcon className="close-circle-icon w-16 h-16" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </Section>
  );
});
